import Vue from 'vue';
import VueResource from 'vue-resource';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
import SocialSharing from 'vue-social-sharing';
import App from './App.vue';
import { ApplicationConstants } from './shared/applicationConstants';
// import MapViewerComponent from './map-viewer/map-viewer.vue';

Vue.use(VueI18n);
Vue.use(VueResource);
Vue.use(VeeValidate);
Vue.use(SocialSharing);

const i18n = new VueI18n({
    locale: ApplicationConstants.defaultLanguageCode,
});

/*eslint-disable*/
const app = new Vue({
    el: '#app',
    i18n,
    methods: {
        setLocale: function(value) {
            i18n.locale = value;
        },
    },
    render: h => h(App),
});

app.$on('langchanged', function(value) {
    this.setLocale(value);
});

// hook to access methods from outside of VueJS instance
export default {
    instamapsVisorApp: app,
}


// WEBPACK FOOTER //
// ./src/main.js